import React from "react";
import { useDispatch } from "@/types/store";
import { useSelector } from "react-redux";
import Select from "react-select";
import * as nextReducer from "@/containers/Next/NextReducer";
import styles from "./style.module.css";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
const LinkedComparisonSelect = ({ id, style, menuPlacement, disabled, isChat, forceActiveTab }) => {
    const dispatch = useDispatch();
    const nextId = id;
    const linkedComparisonProjects = useSelector((state) => nextReducer.getLinkedComparisonProjects(state, nextId)) ?? {};
    const focusModeOptions = useSelector((state) => nextReducer.getLinkedComparisonFocusOptions(state, nextId));
    const linkedComparisonCreating = useSelector((state) => nextReducer.getIsLinkedComparisonCreating(state, nextId));
    const creatingOptions = Object.keys(linkedComparisonCreating ?? {})
        .filter((title) => linkedComparisonCreating[title] === true)
        .map((title) => ({
        label: (React.createElement("div", { className: styles.linkedCreateOption },
            React.createElement(LoadingIndicator, { style: { margin: "0px", marginLeft: "-22px", marginRight: "-12px", transform: "scale(0.4)" } }),
            title)),
        value: title,
        isDisabled: true
    }));
    const retOptions = [...(focusModeOptions ?? []), ...(creatingOptions ?? [])];
    const nDatasetId = useSelector((state) => nextReducer.getDatasetId(state, nextId));
    if (Object.keys(linkedComparisonProjects).length === 0 && retOptions.length === 0)
        return null;
    if (isChat)
        return (React.createElement("div", { className: styles.linkedSelect, style: style !== undefined ? style : undefined },
            (creatingOptions ?? []).length > 0 ? (React.createElement("div", null,
                React.createElement(LoadingIndicator, { style: { margin: "0px", marginRight: "-6px", transform: "scale(0.5)" } }))) : (React.createElement("div", null)),
            React.createElement("div", { style: { width: "100%" } },
                React.createElement(Select, { options: retOptions, onChange: (val) => val?.isCreating === true
                        ? Promise.resolve()
                        : dispatch(nextReducer.updateDatasetId(nextId, val?.datasetId)), value: retOptions.find((k) => Number(k?.datasetId) === Number(nDatasetId)), menuPlacement: menuPlacement, isDisabled: disabled, styles: {
                        menu: (baseStyles) => ({
                            ...baseStyles,
                            minWidth: "220px"
                        })
                    }, placeholder: "Creating..." }))));
    return (React.createElement("div", { className: styles.linkedSelect, style: style !== undefined ? style : undefined },
        (creatingOptions ?? []).length > 0 ? (React.createElement("div", null,
            React.createElement(LoadingIndicator, { style: { margin: "0px", marginRight: "-6px", transform: "scale(0.5)" } }))) : (React.createElement("div", null)),
        React.createElement("div", { style: { width: "100%" } },
            React.createElement(Select, { options: retOptions, onChange: (val) => val?.isCreating === true
                    ? Promise.resolve()
                    : dispatch(nextReducer.openComparisonProject(val?.value, undefined, forceActiveTab)), value: retOptions.find((k) => Number(k?.value) === Number(nextId)), menuPlacement: menuPlacement, isDisabled: disabled, styles: {
                    menu: (baseStyles) => ({
                        ...baseStyles,
                        minWidth: "220px",
                        right: 0,
                        width: "100%"
                    })
                }, placeholder: "Creating..." }))));
};
export default LinkedComparisonSelect;
